export enum RequestPaths {
  ChooseCourt = 'choose-court',
  Recordings = 'recordings',
  Transcripts = 'transcripts',
}

export enum RequestChooseCourtParams {
  RequestType = 'requestType',
}
